import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Product } from '@models/product';
import { environment } from '@environments/environment';
import { ActivatedRoute } from '@angular/router';
import { Image } from 'src/app/models/image';

const LENS_SIZE  = 180; // px — diamètre de la bulle
const ZOOM_LEVEL = 3;   // ×3

@Component({
  selector: 'gob-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  @Input() product: Product;
  @ViewChild('mainImg') mainImgRef: ElementRef<HTMLImageElement>;

  indImg: number = 0;
  isZooming: boolean = false;
  lensStyle: { [key: string]: string } = {};

  get images(): Image[] {
    let differentialPricing = this.router.snapshot.queryParamMap.get('price');

    const images = differentialPricing
      ? [...this.product.images, this.product.mainImage]
      : [this.product.mainImage, ...this.product.images];

    return images.filter(img => img?.name);
  }

  constructor(private router: ActivatedRoute) {}

  ngOnInit(): void {}

  trackImage(index: number, img: any) {
    return img.name;
  }

  getImage(ind: number) {
    if (!this.images || !this.images?.length)
      return 'asset/img/logo/logo.png';
    return `${environment.imgUrl}/product/${this.images[ind].name}`;
  }

  getMainImage() {
    if (!this.product || !this.product.mainImage == null)
      return 'asset/img/logo/logo.png';
    return `${environment.imgUrl}/product/${this.product.mainImage.name}`;
  }

  // ─── Zoom logic ────────────────────────────────────────────────────────────

  onZoomEnter(event: MouseEvent) {
    this.isZooming = true;
    this.updateLens(event);
  }

  onZoomLeave() {
    this.isZooming = false;
    this.lensStyle = {};
  }

  onZoomMove(event: MouseEvent) {
    if (!this.isZooming) return;
    this.updateLens(event);
  }

  private updateLens(event: MouseEvent) {
    const img = this.mainImgRef?.nativeElement;
    if (!img) return;

    const rect = img.getBoundingClientRect();

    // Position de la souris en pourcentage dans l'image
    const xRatio = Math.max(0, Math.min(1, (event.clientX - rect.left)  / rect.width));
    const yRatio = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));

    // Taille du background zoomé
    const bgW = rect.width  * ZOOM_LEVEL;
    const bgH = rect.height * ZOOM_LEVEL;

    // Décalage du background pour centrer sur le curseur
    const bgX = xRatio * bgW - LENS_SIZE / 2;
    const bgY = yRatio * bgH - LENS_SIZE / 2;

    // Position de la bulle relative au conteneur (img-container)
    const containerRect = (img.closest('.img-container') as HTMLElement).getBoundingClientRect();
    const offset = 16;
    let lensX = event.clientX - containerRect.left + offset;
    let lensY = event.clientY - containerRect.top  - LENS_SIZE / 2;

    // Éviter de sortir du conteneur
    const maxX = containerRect.width  - LENS_SIZE - 4;
    const maxY = containerRect.height - LENS_SIZE - 4;
    lensX = Math.max(4, Math.min(maxX, lensX));
    lensY = Math.max(4, Math.min(maxY, lensY));

    this.lensStyle = {
      width:               `${LENS_SIZE}px`,
      height:              `${LENS_SIZE}px`,
      left:                `${lensX}px`,
      top:                 `${lensY}px`,
      backgroundImage:     `url('${img.src}')`,
      backgroundSize:      `${bgW}px ${bgH}px`,
      backgroundPosition:  `-${bgX}px -${bgY}px`,
    };
  }
}